import React from 'react';

import { TabDataCard } from '@repo/ui/Tabs';
import { DataCardGroup } from '@repo/ui/Card';
import { formatDate } from '@repo/util/formatDate';
import { InfoPopover } from '@repo/ui/Popover';

import DIDS_SHOW_Q from '../gql/show.gql';
import { ResultOf } from '@graphql-typed-document-node/core';

export interface DidOverviewProps {
  did: ResultOf<typeof DIDS_SHOW_Q>['did'];
  loading: boolean;
}

const DidOverview = ({ did, loading }: DidOverviewProps) => {
  const DidOverviewData: DataCardGroup[] = [
    {
      groupTitle: 'overview',
      columnCount: 3,
      groupData: [
        {
          label: 'Type',
          entry: (
            <div className="">
              {did?.type === 'TENDLC' ? <span>10DLC</span> : <span>{did?.type}</span>}
            </div>
          ),
        },

        {
          label: 'Activation Date',
          entry: loading || !did?.insertedAt ? '' : formatDate(did.insertedAt),
        },

        {
          label: 'BYON',
          entry: (
            <InfoPopover btnText={did?.isByon ? 'Yes' : 'No'} btnIcon="info" size="sm">
              <span className="break-normal text-pretty">
                {did?.isByon
                  ? 'BYON (Bring Your Own Number): A landline or VoIP number you own with your current carrier that you have connected to Swift to enable SMS messaging on your account.   '
                  : 'Number has been provided by Swift SMS Gateway'}
              </span>
            </InfoPopover>
          ),
        },
      ],
    },
    {
      groupTitle: 'capabilities',
      columnCount: 2,
      groupData: [
        {
          label: 'Capabilities',
          entry: (
            <div className="">
              {did?.smsEnabled && <span>SMS</span>}
              {did?.smsEnabled && did?.mmsEnabled && ', '}
              {did?.mmsEnabled && <span>MMS</span>}
            </div>
          ),
        },
      ],
    },
  ];

  return (
    <TabDataCard
      title={did?.number ?? '???'}
      loading={loading}
      skeletonCount={4}
      data={DidOverviewData}
      size="md"
    />
  );
};

export default DidOverview;
